import { FACTIONS } from '../gameplay/factions';
import type { FactionSelection } from '../gameplay/factions';

export class FactionBadgeLayer {
  readonly element: HTMLElement;

  constructor(selection: FactionSelection) {
    const def = FACTIONS[selection.factionId];

    this.element = document.createElement('div');
    this.element.className = 'faction-badge';
    this.element.style.setProperty('--badge-color', def.uiColor);
    this.element.style.setProperty('--badge-glow', def.uiGlow);

    const emblem = document.createElement('div');
    emblem.className = 'faction-badge-emblem';
    emblem.innerHTML = def.emblem;

    const label = document.createElement('div');
    label.className = 'faction-badge-label';
    label.textContent = def.displayName;

    this.element.append(emblem, label);
  }
}
